var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaKrankentransport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#c55656;}.cls-3{fill:#f5f7fa;}.cls-4{fill:#e3e7f0;}.cls-5{fill:#a3ccee;}.cls-6{fill:#b72c2c;}.cls-7{fill:#59667c;}.cls-8{fill:#959cb3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.34,20.94A12.67,12.67,0,0,0,54.69,33.59V46.25H80V33.59A12.67,12.67,0,0,0,67.34,20.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.26,73.87,114,40.63,96,37.81H8V96.88l72,5.62,72-5.62V81.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.28,73.88,116.8,37.81H80V102.5l72-5.62V81.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.86,46.25H96V73.87h27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,96.88v29.53H152V96.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80,96.88v29.53h72V96.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.55,65.09H38.09V54.55h8.44V65.09H57.08v8.44H46.53V84.08H38.09V73.53H27.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.13,122.19a16.88,16.88,0,1,1-16.88-16.88,16.87,16.87,0,0,1,16.88,16.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.69,122.19a8.44,8.44,0,1,1-8.44-8.44,8.44,8.44,0,0,1,8.44,8.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M59.19,122.19a16.88,16.88,0,1,1-16.88-16.88,16.87,16.87,0,0,1,16.88,16.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.75,122.19a8.44,8.44,0,1,1-8.44-8.44,8.44,8.44,0,0,1,8.44,8.44Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaKrankentransport);
export default __webpack_public_path__ + "static/media/ka_krankentransport.a9139d79234bc57d5aaa503a354d3840.svg";
export { ForwardRef as ReactComponent };